import { AvailabilityData } from '~/context/srp/InventoryContext';
import type { AvailabilityVehicle, Vehicle } from '~/contracts/srp';

export const addAvailabilityToVehicles = (
  vehicles: Vehicle[],
  availabilityVehicles: AvailabilityVehicle[]
): Vehicle[] =>
  vehicles.map<Vehicle>(vehicle => {
    const { soonestPickup, soonestDelivery } =
      availabilityVehicles.find(data => data.vehicleId === vehicle.vehicleId) ??
      {};
    const { content: pickupInfo } = soonestPickup ?? {};
    const { content: deliveryInfo } = soonestDelivery ?? {};

    return { ...vehicle, pickupInfo, deliveryInfo };
  });

export const convertAvailabilityVehiclesToMap = (
  availabilityVehicles: AvailabilityVehicle[]
) =>
  availabilityVehicles.reduce<Record<number, AvailabilityData>>((acc, v) => {
    acc[v.vehicleId] = {
      soonestPickup: v.soonestPickup,
      soonestDelivery: v.soonestDelivery
    };

    return acc;
  }, {});
